<div class="configuration-dialog">
  <aside class="configuration-nav">
    <h2 class="configuration-title">Configuration</h2>
    <button *ngFor="let s of sections"
            type="button"
            class="configuration-nav-item"
            [class.active]="section === s.id"
            (click)="section = s.id">
      <br-icon>{{ s.icon }}</br-icon>
      <span>{{ s.label }}</span>
    </button>
  </aside>

  <section class="configuration-content">
    <button mat-icon-button class="configuration-close" mat-dialog-close aria-label="Close configuration">
      <br-icon>close</br-icon>
    </button>

    <div *ngIf="section === 'account'" class="tc-card br-card account-section">
      <header class="tc-toolbar">
        <h2 class="tc-title">Account</h2>
      </header>

      <div *ngIf="accountLoading" class="tc-loading">Loading...</div>
      <div *ngIf="accountError" class="account-state account-error br-alert br-alert--danger">
        <span>Account details could not be loaded.</span>
        <button class="br-btn br-btn--ghost" type="button" (click)="loadAccount()">Retry</button>
      </div>

      <dl *ngIf="account && !accountLoading" class="account-details">
        <div class="account-detail-row">
          <dt>Company</dt>
          <dd>{{ account.companyName || '—' }}</dd>
        </div>
        <div class="account-detail-row">
          <dt>Username</dt>
          <dd>{{ account.userName || '—' }}</dd>
        </div>
      </dl>

      <div *ngIf="account && !accountLoading" class="account-actions">
        <button type="button" class="br-btn br-btn--ghost" (click)="openChangePassword()">
          Change password
        </button>
      </div>
    </div>

    <app-company-information *ngIf="section === 'account'"></app-company-information>

    <app-configuration-users *ngIf="section === 'users'"></app-configuration-users>
    <app-configuration-roles *ngIf="section === 'roles'"></app-configuration-roles>
    <app-configuration-apikeys *ngIf="section === 'apiKeys'"></app-configuration-apikeys>
  </section>
</div>
